<template>
  <GModal v-if="isOpen" class="modal--report normalize-gutter">
    <div slot="header">
      <button type="button" class="close" aria-label="Close">
        <img src="/assets/img/icons/close-modal.svg" alt="icon-close-modal" @click.prevent="closeModal" />
      </button>
    </div>
    <div slot="body" class="body">
      <h2 class="heading">Report Content</h2>
      <p class="copywriting">Pilih alasan kenapa Anda ingin melaporkan konten ini:</p>

      <ul class="list">
        <li class="list__item">
          <label class="radio-donut">
            <input v-model="reportType" type="radio" name="type" value="spam" checked />
            Spam
            <span></span>
          </label>
        </li>
        <li class="list__item">
          <label class="radio-donut">
            <input v-model="reportType" type="radio" name="type" value="offensive" />
            Offensive
            <span></span>
          </label>
        </li>
        <li class="list__item">
          <label class="radio-donut">
            <input v-model="reportType" type="radio" name="type" value="inappropriate" />
            Inappropriate
            <span></span>
          </label>
        </li>
      </ul>
      <div class="text-center wrapper-button">
        <button
          v-if="isLoadingFinish"
          type="button"
          class="button button-inline btn red"
          :disabled="!reportType"
          @click.prevent="report()"
        >
          Submit
        </button>
        <button v-else type="button" class="button button-inline btn red">Processing..</button>
      </div>
    </div>
  </GModal>
</template>

<script>
export default {
  name: 'modal-report',
  computed: {
    isOpen() {
      return this.$store.state.modal.report.isOpen;
    },
    isLoadingFinish() {
      return this.$store.state.modal.report.isLoadingFinish;
    },
    reportType: {
      get() {
        return this.$store.state.modal.report.type;
      },
      set(newVal) {
        this.$store.commit('setTypeOfModalReport', newVal);
      },
    },
  },
  methods: {
    closeModal() {
      this.$store.commit('setOpenModal', {
        stateName: 'report',
        newVal: false,
      });
    },
    report() {
      this.$store.dispatch('reportNewsfeed');
    },
  },
};
</script>

<style lang="scss">
.modal--report {
  .button {
    width: 147px;
    font-size: 14px;
  }

  .copywriting {
    margin: 0 0 12px 0;
    font: 14px/24px 'lato-regular', sans-serif;
    color: #231f20;
  }

  .heading {
    color: #231f20;
    margin: 0 0 8px 0;
    font: 13px/15px 'lato-bold';
    letter-spacing: normal;
  }

  .list {
    margin-bottom: 24px;
  }

  .list__item {
    margin-bottom: 5px;
  }

  .modal-content {
    padding: 16px;
    position: relative;
  }

  .modal-dialog {
    width: 300px;
    margin: 100px auto;
  }

  .modal-header {
    .close {
      top: -2px;
      margin: 0;
      font-size: 15px;
      right: 0;

      > img {
        width: 20px;
      }
    }
  }

  .radio-donut {
    color: #231f20;
    font: normal 14px 'lato-regular';
  }
}
</style>
